// react
import { useEffect } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';

// store
import { setTargetOrgId } from 'store/slices/registrationSlice';
import { dispatch } from 'store';

// components
import { SignInV2 as SignInPage } from '@karehero/llama/pwa/pages/SignInV2/SignInV2';

// hooks
import { useAuth } from 'hooks';

/**
 * SignIn shows the sign in page.
 * If an organizationID is provided in the URL params or search params, it will
 * be stashed in state for post-redirect.
 */
export const SignIn = () => {
  // hooks
  const { signIn, register } = useAuth();
  const [searchParams] = useSearchParams();
  const { organizationID: routerOrganizationID } = useParams();

  // effects
  // We can get orgID from either search params or URL params. Either way,
  // stash it in state for post-redirect.
  useEffect(() => {
    const orgID = routerOrganizationID || searchParams.get('organizationID');
    if (orgID) dispatch(setTargetOrgId(orgID));
  }, [searchParams, routerOrganizationID, dispatch]);

  return <SignInPage onRegister={register} onSignIn={signIn} />;
};

SignIn.displayName = 'SignIn';
export default SignIn;
